import { UserIcon } from "@/components/button/IconButton"
import { Sidepanel } from "@/components/sidepanel/Sidepanel"
import { formatTime } from "@/lib/formatTime"
import { Message } from "src/types"
import styled from "styled-components"

const Recipients = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 16px;
`

const RecipientsList = styled.div`
  max-height: calc(100vh - 120px);
  overflow-y: auto;
`

const RecipientItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 28px;
`
const HeaderBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  img {
    width: 24px;
    height: 24px;
  }
`

const RecipientReadAtTime = styled.span`
  font-size: 12px;
  color: #999;
`
export const ViewMessageModal = ({
  message,
  onClose,
}: {
  message: Message
  onClose: () => void
}) => {
  const hasContent = message?.recipients && message.recipients.length > 0

  const sortedRecipients = hasContent
    ? [...message.recipients]?.sort((a, b) => {
        if (a.readAt && !b.readAt) return -1
        if (!a.readAt && b.readAt) return 1
        if (a.readAt && b.readAt) {
          // sort by oldest read first
          return a.readAt > b.readAt ? 1 : -1
        }
        return 0
      })
    : []

  return (
    <Sidepanel open={hasContent} onClose={onClose} style={{ width: "350px" }}>
      {hasContent ? (
        <Recipients>
          <HeaderBlock>
            {UserIcon}
            {message.recipients?.length || 0} Darbinieki
            {` (${
              message.recipients?.filter((recipient) => !recipient.readAt)
                .length || 0
            } nelasīti)`}
          </HeaderBlock>
          <RecipientsList>
            {sortedRecipients?.map((recipient) => (
              <RecipientItem key={recipient.id}>
                <span>{recipient.readAt ? "✅" : "❌"}</span>
                <span>{recipient.toUser?.name || "Nezināms"}</span>
                {recipient.readAt ? (
                  <RecipientReadAtTime>
                    ({formatTime(recipient.readAt)})
                  </RecipientReadAtTime>
                ) : null}
              </RecipientItem>
            ))}
          </RecipientsList>
        </Recipients>
      ) : null}
    </Sidepanel>
  )
}
